<template>
  <div class="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
    <div class="login-form login-signin">
      <div class="text-center mb-5">
        <h3 class="font-size-h1">Подтверждение регистрации</h3>
      </div>

      <v-alert type="success" :value="sentRepeatCode">
        <div class="alert-text">На ваш номер телефона отправлен код подтверждения</div>
      </v-alert>
      <v-alert type="error" :value="errors.length > 0">
        <div v-for="(error, i) in errors" :key="i">{{ error }}</div>
      </v-alert>

      <v-form ref="form" v-model="valid" :lazy-validation="false">
        <v-text-field
          v-model="form.code"
          type="text"
          :rules="codeRules"
          label="Код подтвержденения"
          required
        ></v-text-field>
        <div class="d-flex justify-end">
          <a href="#" @click.prevent="repeatCode" v-if="this.form.phone">Выслать код повторно</a>
        </div>
        <div class="d-flex align-center justify-space-between mt-5">
          <v-btn color="primary" @click="onSubmit" :loading="submitting">Подтвердить</v-btn>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import { CONFIRM } from "@/core/services/store/auth.module";
import { REPEAT_CODE } from "@/core/services/store/auth.module";
import { RESET_ERRORS } from "@/core/services/store/auth.module";

export default {
  name: "register",
  metaInfo: {
    title: "Подтверждение регистрации",
  },
  data() {
    return {
      submitting: false,
      valid: true,
      errors: [],
      form: {
        code: "",
      },
      sentRepeatCode: false,
      codeRules: [(v) => !!v || "не может быть пустым"],
    };
  },
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.submitting = true;
        this.$store.dispatch(RESET_ERRORS);
        this.sentRepeatCode = false;

        this.$store
          .dispatch(CONFIRM, {
            code: this.form.code,
            role: process.env.VUE_APP_ROLE,
          })
          .then(() => this.$router.push({ name: "vehicles" }))
          .catch((response) => {
            this.errors = response.data.errors.base;
          })
          .finally(() => (this.submitting = false));
      }
    },
    repeatCode() {
      this.$store.dispatch(RESET_ERRORS);
      this.sentRepeatCode = false;
      this.errors = [];
      this.submitting = true;
      this.$store
        .dispatch(REPEAT_CODE)
        .then(() => {
          this.sentRepeatCode = true;
        })
        .catch((response) => {
          this.errors = response.data.errors.base;
        })
        .finally(() => (this.submitting = false));
    },
  },
};
</script>
